<template>
	<div class="friend-item" 
		:class="[active ? 'active' : '', isDragging ? 'dragging' : '']" 
		@contextmenu.prevent="showRightMenu($event)"
		draggable="true"
		@dragstart="onDragStart"
		@dragend="onDragEnd">
		<div class="friend-avatar">
			<head-image :size="42" :name="friend.nickName" :url="friend.headImage" :online="friend.online">
			</head-image>
		</div>
		<div class="friend-info">
			<div class="friend-name">{{ friend.remarkName || friend.nickName }}</div>
<!--			<div class="friend-code">聊天号：{{ friend.userCode }}</div>-->
			<div class="friend-online">
				<i class="el-icon-monitor online" v-show="friend.onlineWeb" title="电脑设备在线">
					<span class="online-icon"></span>
				</i>
				<i class="el-icon-mobile-phone online" v-show="friend.onlineApp" title="移动设备在线">
					<span class="online-icon"></span>
				</i>
			</div>
		</div>
		<right-menu v-show="menu && rightMenu.show" :pos="rightMenu.pos" :items="rightMenu.items"
			@close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
		<slot></slot>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from "../common/RightMenu.vue";

export default {
	name: "friendItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {
			isDragging: false,
			rightMenu: {
				show: false,
				pos: {
					x: 0,
					y: 0
				},
				items: [{
					key: 'CHAT',
					name: '发送消息',
					icon: 'el-icon-chat-dot-round'
				}, {
					key: 'DELETE',
					name: '删除好友',
					icon: 'el-icon-delete'
				}]
			}
		}
	},
	methods: {
		showRightMenu(e) {
			this.rightMenu.pos = {
				x: e.x,
				y: e.y
			};
			this.rightMenu.show = "true";
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.friend);
		},
		onDragStart(e) {
			try {
				if (!e.dataTransfer) {
					console.warn('拖拽失败：dataTransfer不可用', { friend: this.friend });
					return;
				}

				// 设置拖拽状态
				this.isDragging = true;
				
				// 记录日志
				console.log('好友项拖拽开始', { 
					friend: this.friend,
					index: this.index,
					friendId: this.friend ? this.friend.id : null 
				});
				
				// 触发父组件的拖拽事件（由FriendGroupList处理）
				// 注意：我们不在这里设置dataTransfer，而是让父组件处理
				
				// 设置拖拽图像效果
				const dragImage = document.createElement('div');
				dragImage.textContent = this.friend.remarkName || this.friend.nickName || '好友';
				dragImage.style.padding = '8px 12px';
				dragImage.style.backgroundColor = '#e6f1fc';
				dragImage.style.border = '1px solid #409eff';
				dragImage.style.borderRadius = '4px';
				dragImage.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
				dragImage.style.position = 'absolute';
				dragImage.style.top = '-1000px';
				dragImage.style.fontSize = '14px';
				document.body.appendChild(dragImage);
				
				try {
					e.dataTransfer.setDragImage(dragImage, 10, 10);
					
					// 备用：直接在这里也设置一份数据，以防父组件的事件处理失败
					e.dataTransfer.setData('application/json', JSON.stringify({
						friend: {
							id: this.friend.id,
							nickName: this.friend.nickName,
							remarkName: this.friend.remarkName,
							headImage: this.friend.headImage
						}
					}));
				} catch (err) {
					console.warn('设置拖拽图像或数据失败', err);
				}
				
				// 清理
				setTimeout(() => {
					document.body.removeChild(dragImage);
				}, 100);
			} catch (error) {
				console.error('拖拽开始出错:', error);
				this.isDragging = false;
			}
		},
		onDragEnd(e) {
			try {
				console.log('好友项拖拽结束', { 
					friend: this.friend,
					index: this.index,
					friendId: this.friend ? this.friend.id : null 
				});
				this.isDragging = false;
			} catch (error) {
				console.error('拖拽结束出错:', error);
				this.isDragging = false;
			}
		}
	},
	props: {
		active: {
			type: Boolean
		},
		index: {
			type: Number
		},
		friend: {
			type: Object,
			required: true
		},
		menu: {
			type: Boolean,
			default: true
		}
	}

}
</script>

<style scope lang="scss">
.friend-item {
	height: 50px;
	display: flex;
	position: relative;
	padding: 5px 10px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background-color: var(--im-background-active-dark);
	}

	&.dragging {
		opacity: 0.6;
		background-color: #e6f1fc;
		border: 1px dashed #409eff;
	}

	.friend-avatar {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.friend-info {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 10px;
		text-align: left;

		.friend-name {
			font-size: var(--im-font-size);
			white-space: nowrap;
			overflow: hidden;
		}

		.friend-code {
			font-size: 12px;
			color: #999;
			white-space: nowrap;
			overflow: hidden;
		}

		.friend-online {
			.online {
				font-weight: bold;
				padding-right: 2px;
				font-size: 16px;
				position: relative;
			}

			.online-icon {
				position: absolute;
				right: 0;
				bottom: 0;
				width: 6px;
				height: 6px;
				background: limegreen;
				border-radius: 50%;
				border: 1px solid white;
			}
		}
	}
}
</style>
